export const PROSPER_PARAMETERS = {
    MIN_AGE: 18,
    MAX_AGE: 60,
    // MIN_CONTRIBUTION: 65,
    MIN_CONTRIBUTION: 100,
    MIN_HOUSEHOLD_INCOME: 50000,
    INELIGIBLE_STATES: ['NY', 'NJ', 'FL', 'CA'],

    SERVE_MIN_AGE: 26,
    SERVE_MAX_AGE: 60,
    SERVE_MIN_HOUSEHOLD_INCOME: 50000,
    SERVE_MIN_CONTRIBUTION: 100,
    SERVE_MIN_BMI: 18,
    SERVE_MAX_BMI: 38,
    SERVE_TOBACCO_USAGE: [false],
};
